export const getStarted = 'Get started!'
export const welcomeTitle = 'Welcome to MyTamilDate!'
export const welcomeDescription =
	"Let's build your profile to help you showcase your amazing self and meet someone great!"

export const btnNames = {
	getStarted
}
